import { Separator } from "@/components/ui/separator"
import { SidebarNav } from "./side-nav"
import { useMediaQuery } from "@/hooks/use-media-query";
import { isDesktopSize } from "utils/is-desktop";
import { Bell, CreditCard, History, Settings, Settings2 } from "lucide-react";
import { forwardRef } from "react";
import { cn } from "@/lib/utils";

const sidebarNavItems = [
    {
        title: "Cuenta",
        href: "/settings/account",
        icon:(<Settings className="w-8 h-8" />)
    },
    {
        title: "Preferencias",
        href: "/settings/preferences",
        icon:(<Settings2 className="w-8 h-8" />)
    },
    {
        title: "Suscripción",
        href: "/settings/subscription",
        icon: (<CreditCard className="w-8 h-8" />)
    },
    {
        title: "Historial de Pedidos",
        href: "/settings/orders",
        icon: (<History className="w-8 h-8" />)
    },
    // {
    //     title: "Notificaciones",
    //     href: "/settings/notifications",
    //     icon: (<Bell className="w-8 h-8" />)
    // }
];


interface SettingsLayoutProps {
    children: React.ReactNode
}

export default function SettingsLayout({ children }: SettingsLayoutProps) {
    const isDesktop = useMediaQuery(isDesktopSize);
    return (
        <div className="space-y-6 p-6 md:px-10 md:pt-5 md:pb-16">            
 
            <div className="flex flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">                
            {
            (isDesktop)&&(
                <SidebarNav items={sidebarNavItems} /> 
            )
            }
            {
            (!isDesktop)&&(!children)&&( <SidebarNav items={sidebarNavItems} />)
            }                    
                <div className="flex-1 lg:max-w-[60%]">{children}</div>
            </div>
        </div>
    )
}
